import { render, staticRenderFns } from "./editCompany.vue?vue&type=template&id=55609ee2&"
import script from "./editCompany.js?vue&type=script&lang=js&"
export * from "./editCompany.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports